import './Main.scss'
import Hero from '../../components/Hero/Hero'
import Food from '../../components/Food/Food'
import Events from '../../components/Events/Events'
import Attire from '../../components/Attire/Attire'
import Footer from '../../components/Footer/Footer'

function Main() {
    return (
        <>
            <Hero/>
            <Food/>
            <Events/>
            <Attire/>
            <Footer/>
        </>
    )
}

export default Main;